import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

// 查询组织已有增值服务列表
export const queryOrgModules: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setOrgModules', { ...state.modules, loading: true });
    const res = await $http.post('/v1/baseinfo/org/modules', payload);
    commit('setOrgModules', { data: res });
  } catch (e) {
    commit('setOrgModules', { data: [] });
  }
};

// 查询未设置的增值服务列表
export const queryOrgUnModules: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setOrgUnModules', { ...state.unModules, loading: true });
    const res = await $http.post('/v1/system/module/list', payload);
    commit('setOrgUnModules', { data: res });
  } catch (e) {
    commit('setOrgUnModules', { data: [] });
  }
};

// 批量添加增值服务
export const addOrgModule: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await $http.post('/v1/baseinfo/org/addmodule', payload);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 批量删除增值服务
export const deleteOrgModule: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/baseinfo/org/deletemodule', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 锁定增值服务
export const lockOrgModule: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/baseinfo/org/lockmodule', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 激活增值服务
export const activeOrgModule: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/baseinfo/org/activatemodule', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};
